<template>
  <v-card min-width="400">
    <v-card-title>Search Clients </v-card-title>
    <v-card-subtitle>search clients for relevant notes</v-card-subtitle>
    <v-alert
      v-model="userError"
      type="error"
      text="No Users found"
      closable
    ></v-alert>
    <v-card-text>
      <v-text-field
        density="compact"
        variant="outlined"
        label="Name, Mobile Phone number or Email"
        single-line
        hide-details
        @input="debouncedProcessSearch"
      ></v-text-field>
      <v-radio-group v-model="searchParam" :inline="true">
        <v-radio label="Name" value="name"></v-radio>
        <v-radio label="Email" value="email"></v-radio>
        <v-radio label="Phone" value="phone"></v-radio>
      </v-radio-group>
    </v-card-text>
    <v-card-actions>
      <v-btn
        color="light-blue"
        :loading="processingNotes"
        @click="executeSearchRequest"
        variant="flat"
        >Search</v-btn
      >
    </v-card-actions>
    <v-list max-height="300" max-width="400">
      <v-list-item v-for="customer in customers" :key="customer.id">
        <list-customer
          :customer="customer"
          :show-notes="customer.id === selectedItem"
          @toggle-addnote="$emit('toggle-addnote', customer.id)"
          @selected="selectItem"
        ></list-customer>
      </v-list-item>
    </v-list>
  </v-card>
</template>

<script>
import axios from "axios";
import ListCustomer from "./ListCustomer.vue";
export default {
  name: "SearchNotesBox",
  components: { ListCustomer },
  emits: ["toggle-addnote"],
  setup() {
    const apiURL = import.meta.env.VITE_API_URL;
    return { apiURL };
  },
  data() {
    return {
      search: "",
      customers: [],
      processingNotes: false,
      userError: false,
      searchParam: "name",
      selectedItem: null,
    };
  },
  watch: {
    search() {
      this.executeSearchRequest();
    },
  },
  created() {
    this.debouncedProcessSearch = this.debounced(this.processSearch);
  },
  methods: {
    debounced(func, timeout = 500) {
      let timer;
      return (...args) => {
        clearTimeout(timer);
        timer = setTimeout(() => {
          func.apply(this, args);
        }, timeout);
      };
    },
    async processSearch(event) {
      this.search = event.target.value;
    },
    async executeSearchRequest() {
      if (!this.search) return;
      this.processingNotes = true;
      delete axios.defaults.headers.common["X-Requested-With"];
      const params = {};
      params[this.searchParam] = this.search;

      await axios
        .get(this.apiURL + "customers", {
          params: params,
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            Accept: "*/*",
          },
          data: {},
        })
        .then((res) => {
          this.processingNotes = false;
          this.customers = res.data.data;
        })
        .catch((error) => {
          console.log(error.request);
          this.userError = true;
          setTimeout(() => (this.userError = false), 1500);
          this.processingNotes = false;
        });
    },
    selectItem(id) {
      this.selectedItem = this.selectedItem === id ? null : id; // Toggle selection
    },
  },
};
</script>
